import { FC, HTMLProps } from 'react';
import dayjs from 'dayjs';

// Shared UI Library Components
import { CustomIcon, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './call-notification.scss';

// Models
import { ICallNotification } from '../../../../interfaces/chat.interfaces';

type TCallNotificationProps = HTMLProps<HTMLDivElement> & {
  callInfo: ICallNotification;
}

export const CallNotification: FC<TCallNotificationProps> = (
  { callInfo, ...props }: TCallNotificationProps
) => {
  const { created_at } = callInfo;

  return (
    <div className="call-notification" { ...props }>
      <div className="call-notification--body">
        <div className="body-item body-item--time">
          { dayjs(created_at).format('hh:mm A') }
        </div>
        <div className="body-item body-item--icon">
          <CustomIcon name={ EIconName.NotificationsActiveFill } size={'size-md'}/>
        </div>
        <div className="body-item body-item--message">
          I’m back, you may call me again
        </div>
      </div>
    </div>
  );
};

